import { render, staticRenderFns } from "./PasswordEditor.vue?vue&type=template&id=16a50e5f&scoped=true"
import script from "./PasswordEditor.vue?vue&type=script&lang=js"
export * from "./PasswordEditor.vue?vue&type=script&lang=js"
import style0 from "./PasswordEditor.vue?vue&type=style&index=0&id=16a50e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a50e5f",
  null
  
)

export default component.exports